import React, { useState } from "react";
import I18n from 'i18n.js.erb'
import { addHtmlElementClass, isDefined, removeHtmlElementClass } from "../../utils/utils";

const GlobalSearchBar = ({
  secondRow
}) => {

  const [value, setValue] = useState('');
  const [focus, setFocus] = useState(false);


  const handleNavigation = () => {
    if (isDefined(value)) {
      const val = value.trim()
      window.location = `/grading_certificate/${val}`;
    }
  }



  const handleKeyDown = (e) => {
    e.stopPropagation();
    if (e.key === 'Enter' && focus)
      handleNavigation();
  }


  const handleSearch = (e) => {
    e.stopPropagation();
    handleNavigation()
  }



  return (
    <React.Fragment>
      <div className="d-flex flex-row">
        <div className="h-40px px-0 pr-lg-0 mr-1 d-flex">
          <input
            id={`global_search_bar${secondRow ? '_second_row' : ''}`}
            type="search"
            value={value}
            className={'form-control br-20px border-aiG-black-imp h-40px minW-165px minW-lg-165px minW-xxl-450px minW-xl-280px minW-md-450px minW-sm-300px text--truncate slide-animation-container-searchbar'}
            onChange={(e) => setValue(e.target.value)}
            placeholder={I18n.t('js.home_page.searchCardByName')}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onKeyDown={(e) => handleKeyDown(e)}
          />
        </div>

        <div className="d-flex align-items-center px-0">
          <button
            id={`global_search_button${secondRow ? '_second_row' : ''}`}
            type="button"
            className="btn bg-aig-gradient br-50px border-none text-light font-weight-bold h-40px mt-0 mr-1 py-2 slide-animation-container-searchbar"
            onClick={(e) => handleSearch(e)}
          >
            <span>
              {I18n.t("js.advancedSearch.filterComponent.search").toUpperCase()}
            </span>
          </button>

          <img src="/images/close.svg" id={`global_search_close${secondRow ? '_second_row' : ''}`} className="cursor-pointer slide-animation-container-searchbar" alt="Search" height="27" width="27" onClick={() => {
            // addHtmlElementClass(document, "navbar-search", "slide-up");
            removeHtmlElementClass(document, "navbar-search", 'slide-down-searchbar');
            removeHtmlElementClass(document, "global_search_bar", "slide-down-searchbar-input");
            removeHtmlElementClass(document, "global_search_button", "slide-down-searchbar-button");
            removeHtmlElementClass(document, "global_search_close", "slide-down-searchbar-close");
            removeHtmlElementClass(document, "global_search_bar_second_row", "slide-down-searchbar-input");
            removeHtmlElementClass(document, "global_search_button_second_row", "slide-down-searchbar-button");
            removeHtmlElementClass(document, "global_search_close_second_row", "slide-down-searchbar-close");
            removeHtmlElementClass(document, "navbar-second-line", "slide-down");
            addHtmlElementClass(document, "navbar_menu", 'd-xl-flex');
          }}
          />
        </div>
      </div>
    </React.Fragment >
  );
};

export default GlobalSearchBar;
